import { useEffect } from 'react';

import usePollEmailVerificationQuery from '@/v2/domains/Auth/queries/usePollEmailVerificationQuery.hook';
import useUnlockVerifiedSessionMutation from '@/v2/domains/Auth/queries/useUnlockVerifiedSessionMutation.hook';

export default function useUnlockWhenEmailVerified() {
  const { data: me } = usePollEmailVerificationQuery();
  const { mutate: unlockSession, isIdle } = useUnlockVerifiedSessionMutation();

  const isEmailVerified = !!me?.teacher && !me.teacher.emailVerificationPending;

  useEffect(() => {
    if (isEmailVerified && isIdle) {
      unlockSession();
    }
  }, [isEmailVerified, isIdle]);
}
